"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "orta-di-atella": {
    "cef648bf": [{
      "hkey": "f6a106ba",
      "slug": "orta-di-atella",
      "name": "Orta di Atella",
      "primary": true,
      "skipSearch": false
    }],
    "bugnano": [{
      "hkey": "f6a106ba",
      "slug": "orta-di-atella",
      "name": "Orta di Atella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f2e09eab": [{
      "hkey": "f6a106ba",
      "slug": "orta-di-atella",
      "name": "Orta di Atella",
      "primary": true,
      "skipSearch": false
    }],
    "casapuzzano": [{
      "hkey": "f6a106ba",
      "slug": "orta-di-atella",
      "name": "Orta di Atella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;